export function getLocString(dealLocateInfo) {
    if (!dealLocateInfo)
        return '';
    const { city, distance, district } = dealLocateInfo;
    const districtInfo = district || city;
    if (!districtInfo)
        return '';
    if (distance && distance !== '') {
        return ((districtInfo === null || districtInfo === void 0 ? void 0 : districtInfo.length) > 10 ? districtInfo.substring(0, 10) + '...' : districtInfo) + '·' + distance;
    }
    return (districtInfo === null || districtInfo === void 0 ? void 0 : districtInfo.length) > 16 ? districtInfo.substring(0, 16) + '...' : districtInfo;
}
export function getSingleLocString(dealLocateInfo) {
    if (!dealLocateInfo)
        return '';
    const { city, distance, district } = dealLocateInfo;
    const districtInfo = district || city;
    if (!districtInfo)
        return '';
    if (distance && distance !== '') {
        return ((districtInfo === null || districtInfo === void 0 ? void 0 : districtInfo.length) > 10 ? districtInfo.substring(0, 10) + '...' : districtInfo) + ' | ' + distance;
    }
    return (districtInfo === null || districtInfo === void 0 ? void 0 : districtInfo.length) > 16 ? districtInfo.substring(0, 16) + '...' : districtInfo;
}
export function formatPrice(price) {
    if (!price)
        return '';
    let formattedPrice = price === null || price === void 0 ? void 0 : price.toString().replace(/\.00$/, '');
    return formattedPrice === null || formattedPrice === void 0 ? void 0 : formattedPrice.replace(/(\.\d)0$/, '$1');
}
export function formatDiscount(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return value.replace(/(\.\d*[1-9])0*$|\.0*$/, '$1');
}
